































import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  data: () => ({
    items: [
      { title: 'Создать парсер', icon: 'add', href: { name: 'SpiderCreate' } },
      {
        title: 'Создать несколько',
        icon: 'playlist_add',
        href: { name: 'SpiderBulkCreate' },
        admin: true,
      },
      { title: 'Мои парсеры', icon: 'list', href: { name: 'SpiderList' }, showCount: true },
      { title: 'Обходы', icon: 'http', href: { name: 'RunList' } },
      { title: 'Тест XPath', icon: 'find_in_page', href: { name: 'XPathSandbox' } },
      { title: 'Помощь', icon: 'help', href: { name: 'HelpView' } },
      { title: 'Отчеты', icon: 'assessment', href: { name: 'ReportsView' } },
    ],
  }),
  computed: {
    ...mapState('spiders', {
      count: (state: any) => state.itemsCount,
    }),
    ...mapState('auth', { user: (state: any) => state.user }),
    visibleItems() {
      if (this.user == null) {
        return []
      }

      return this.items.filter(x => this.user.is_admin || !x.admin)
    },
  },
})
